import { setViewport } from "@client/actions";
import { connectCustom } from "@client/lib/misc";
import { screenSelector } from "@client/selectors/state";
import { type AppState, type WithClassName } from "@client/types";
import { type ViewportAppStateBase } from "@client/types/AppState/viewport";
import { type WithChildren } from "@client/types/WithChildren";
import classNames from "classnames";
import Viewport, { type ViewportActionProps, type ViewportProps } from "./component";

type Props = Partial<WithClassName> &
  WithChildren & {
    onScreenUpdate?: (data: ViewportAppStateBase) => void;
  };
const mapStateToProps = (state: AppState, { className, ...props }: Props): ViewportProps => {
  return {
    ...props,
    className: classNames(className, screenSelector(state)),
    isEditMode: state.isEditMode,
    viewport: state.viewport
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ViewportActionProps => ({
  onScreenUpdate: (data: ViewportAppStateBase) =>
    props.onScreenUpdate ? props.onScreenUpdate(data) : dispatch(setViewport(data))
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(Viewport);
